import React from 'react'
import ReactDOM from 'react-dom'

import 'antd-mobile/dist/antd-mobile.css'
import 'react-toastify/dist/ReactToastify.css'
import './assets/styles/_index.scss'
import 'swiper/swiper.scss'
import 'rc-collapse/assets/index.css'

import * as serviceWorker from './serviceWorker'

import InitApp from './InitApp'
import { Provider } from 'react-redux'
import store from './store'
import { I18nextProvider } from 'react-i18next'
import i18n from './locales/i18n'
import { getObjectData } from './utils/localStorageHelper'
import { StorageKeys } from './constants'

import { setRestaurantPath } from './actions/orderActions'
import { ensureArray } from './utils/helper'

store.dispatch(
    setRestaurantPath(ensureArray(window.location.pathname.split('/'))[1])
)
// update lang from local
const lang = getObjectData(StorageKeys.appLanguage) || 'en'
i18n.changeLanguage(lang, () => {})

ReactDOM.render(
    <I18nextProvider i18n={i18n}>
        <Provider store={store}>
            <InitApp />
        </Provider>
    </I18nextProvider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
